import { render } from "./AdicionarCentroCosto.vue?vue&type=template&id=1d6664fd&scoped=true"
import script from "./AdicionarCentroCosto.vue?vue&type=script&lang=js"
export * from "./AdicionarCentroCosto.vue?vue&type=script&lang=js"

import "./AdicionarCentroCosto.vue?vue&type=style&index=0&id=1d6664fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6664fd"]])

export default __exports__